<div class="signed-out eshava-text-center">
  <h1>{{'SignedOutTitle'|translate:'ascent'}}</h1>
  <p>{{'SignedOutText'|translate:'ascent'}}</p>
  <button
    type="button"
    class="eshava-btn eshava-btn-primary"
    (click)="signIn()">
    {{'SignIn'|translate:'ascent'}}
  </button>
</div>
